import type { ReactElement } from 'react';

import { ensureDefined } from '@e-socna/utils';
import { RESOLVER_CONTENT_CLASSNAME } from '@e-socna/printer-contract';

import { useDocumentResolverContext } from '../contexts/DocumentResolverContext/hooks/useDocumentResolverContext.hook';
import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDevisReference = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<ReactElement> => {
  const { printerSettings } = useDocumentResolverContext();

  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isSuccess: false,
      isLoading: false,
    };
  }

  const { code } = ensureDefined({
    code: printerSettings?.code ?? 'REFERENCE_INCONNUE',
  });

  const content = (
    <div className={RESOLVER_CONTENT_CLASSNAME}>
      <strong>{code}</strong>
    </div>
  );

  return {
    data: {
      generated: content,
    },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
